import {Select} from '@mantine/core';
import classes from './select.module.css';

export const SelectTheme = Select.extend({
  classNames: {
    section: classes.section,
    option: classes.option,
    dropdown: classes.dropdown,
  },
});